export const FEE_AMOUNT_TYPE = {
  ALL: "",
  FIXED: "fixed",
  PERCENTAGE: "percentage",
};

export const feeAmountTypeLabels = {
  [FEE_AMOUNT_TYPE.ALL]: "All",
  [FEE_AMOUNT_TYPE.FIXED]: "Fixed",
  [FEE_AMOUNT_TYPE.PERCENTAGE]: "Percentage",
};

export const feeAmountTypeFormOptions = [
  { value: FEE_AMOUNT_TYPE.FIXED, label: feeAmountTypeLabels[FEE_AMOUNT_TYPE.FIXED] },
  { value: FEE_AMOUNT_TYPE.PERCENTAGE, label: feeAmountTypeLabels[FEE_AMOUNT_TYPE.PERCENTAGE] },
];

export const feeAmountTypeFilters = [
  { value: FEE_AMOUNT_TYPE.ALL, label: feeAmountTypeLabels[FEE_AMOUNT_TYPE.ALL] },
  { value: FEE_AMOUNT_TYPE.FIXED, label: feeAmountTypeLabels[FEE_AMOUNT_TYPE.FIXED] },
  { value: FEE_AMOUNT_TYPE.PERCENTAGE, label: feeAmountTypeLabels[FEE_AMOUNT_TYPE.PERCENTAGE] },
];
